import React, { useState, useEffect } from 'react';
import { ShoppingCart, Menu, X, Star, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const CandyLandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [heroImage, setHeroImage] = useState('');
  const [productImages, setProductImages] = useState([]);
  const [corporateImage, setCorporateImage] = useState('');
  const [giftBoxImage, setGiftBoxImage] = useState('');
  const [instagramImages, setInstagramImages] = useState([]);

  useEffect(() => {
    setHeroImage('https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=800&h=600&fit=crop');
    setProductImages([
      'https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=300&h=200&fit=crop',
      'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=300&h=200&fit=crop',
      'https://images.unsplash.com/photo-1571506165871-ee72a35bc9d4?w=300&h=200&fit=crop',
      'https://images.unsplash.com/photo-1606312619070-d48b4c652a52?w=300&h=200&fit=crop'
    ]);
    setCorporateImage('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop');
    setGiftBoxImage('https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400&h=300&fit=crop');
    setInstagramImages([
      'https://images.unsplash.com/photo-1515037893149-de7f840978e2?w=300&h=300&fit=crop',
      'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=300&h=300&fit=crop',
      'https://images.unsplash.com/photo-1571506165871-ee72a35bc9d4?w=300&h=300&fit=crop',
      'https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=300&h=300&fit=crop',
      'https://images.unsplash.com/photo-1606312619070-d48b4c652a52?w=300&h=300&fit=crop',
      'https://images.unsplash.com/photo-1587334274328-64186a80aeee?w=300&h=300&fit=crop'
    ]);
  }, []);

  const products = [
    { name: 'Blue Pop Candy Sticks', price: '₦2,500.00', rating: 4.8, image: productImages[0] },
    { name: 'Strawberry Gumballs Premium', price: '₦3,200.00', rating: 4.9, image: productImages[1] },
    { name: 'Rainbow Candy Fun Collection', price: '₦1,800.00', rating: 4.7, image: productImages[2] },
    { name: 'Chocolate Mix Treats Premium', price: '₦4,500.00', rating: 4.6, image: productImages[3] }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="relative">
        <div className="bg-black text-white py-2 px-4 text-center text-sm">
          🍭 GET FREE SHIPPING ON ORDERS OVER ₦10,000 NATIONWIDE
        </div>

        <nav className="bg-white shadow-lg px-4 py-4">
          <div className="max-w-7xl mx-auto flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center">
                <div className="w-6 h-6 border-2 border-white rounded-full border-dashed"></div>
              </div>
              <span className="text-2xl font-bold text-gray-800">Candylicious Creations</span>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <a href="#" className="text-gray-700 hover:text-pink-500 transition-colors">Home</a>
              <a href="#" className="text-gray-700 hover:text-pink-500 transition-colors">Shop</a>
              <a href="#" className="text-gray-700 hover:text-pink-500 transition-colors">About</a>
              <a href="#" className="text-gray-700 hover:text-pink-500 transition-colors">Services</a>
              <a href="#" className="text-gray-700 hover:text-pink-500 transition-colors">Contact</a>
            </div>

            <div className="flex items-center space-x-4">
              <div className="relative">
                <input 
                  type="text" 
                  placeholder="Search candies..." 
                  className="pl-4 pr-8 py-2 border rounded-full text-sm w-48 focus:outline-none focus:ring-2 focus:ring-pink-300"
                />
              </div>
              <ShoppingCart className="w-6 h-6 text-gray-700 hover:text-pink-500 cursor-pointer transition-colors" />
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t">
              <div className="flex flex-col space-y-4 mt-4">
                <a href="#" className="text-gray-700 hover:text-pink-500">Home</a>
                <a href="#" className="text-gray-700 hover:text-pink-500">Shop</a>
                <a href="#" className="text-gray-700 hover:text-pink-500">About</a>
                <a href="#" className="text-gray-700 hover:text-pink-500">Services</a>
                <a href="#" className="text-gray-700 hover:text-pink-500">Contact</a>
              </div>
            </div>
          )}
        </nav>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-pink-200 via-pink-300 to-pink-400 py-20 px-4 overflow-hidden">
        <div className="max-w-7xl mx-auto flex items-center">
          <div className="flex-1 z-10">
            <h1 className="text-5xl md:text-7xl font-bold text-gray-800 mb-6 leading-tight">
              The #1 Retail &<br />
              Wholesale<br />
              supplier for<br />
              American Candy<br />
              in Nigeria.
            </h1>
            <button className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300">
              Shop Now
            </button>
          </div>
          <div className="flex-1 relative">
            {heroImage && (
              <img 
                src={heroImage} 
                alt="Happy person with candy" 
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            )}
          </div>
        </div>
        
        <div className="absolute top-10 right-10 w-16 h-16 bg-yellow-300 rounded-full opacity-70 animate-bounce"></div>
        <div className="absolute bottom-20 left-10 w-12 h-12 bg-blue-300 rounded-full opacity-70 animate-pulse"></div>
        <div className="absolute top-1/2 right-1/4 w-8 h-8 bg-green-300 rounded-full opacity-70"></div>
      </section>

      {/* New Arrivals */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">New Arrivals</h2>
            <p className="text-gray-600">Check out our latest and most celebrated treats</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {products.map((product, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
                <div className="relative">
                  <img 
                    src={product.image} 
                    alt={product.name} 
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4 bg-pink-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                    NEW
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-semibold text-gray-800 mb-2">{product.name}</h3>
                  <div className="flex items-center mb-2">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className={`w-4 h-4 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                    ))}
                    <span className="text-sm text-gray-600 ml-2">({product.rating})</span>
                  </div>
                  <p className="text-pink-500 font-bold text-lg">{product.price}</p>
                  <button className="w-full mt-4 bg-pink-500 text-white py-2 rounded-lg hover:bg-pink-600 transition-colors duration-300">
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              {corporateImage && (
                <img 
                  src={corporateImage} 
                  alt="Corporate services" 
                  className="w-full h-80 object-cover rounded-2xl shadow-xl"
                />
              )}
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">CORPORATE<br />SERVICES</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                We provide corporate candy solutions for your office events, client 
                meetings, and special occasions. Our bulk ordering service offers 
                competitive pricing with flexible delivery options tailored to 
                your business needs.
              </p>
              <button className="bg-gray-800 text-white px-8 py-3 rounded-lg hover:bg-gray-700 transition-colors duration-300">
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Gift Box Services */}
      <section className="py-16 px-4 bg-gradient-to-r from-pink-100 to-purple-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">LUXURY<br />GIFT BOX & PARTY<br />SERVICES</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Create memorable moments with our curated luxury gift boxes and 
                party planning services. Perfect for birthdays, weddings, 
                corporate events, or any special celebration that deserves 
                our finest treats.
              </p>
              <button className="bg-pink-500 text-white px-8 py-3 rounded-lg hover:bg-pink-600 transition-colors duration-300">
                READ MORE
              </button>
            </div>
            <div className="relative">
              {giftBoxImage && (
                <img 
                  src={giftBoxImage} 
                  alt="Gift box services" 
                  className="w-full h-80 object-cover rounded-2xl shadow-xl"
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-16 px-4 bg-gradient-to-r from-pink-400 to-pink-500 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Sign up for Our Newsletter</h2>
          <h3 className="text-4xl font-bold mb-8">RECEIVE 20% OFF</h3>
          <div className="flex justify-center">
            <div className="flex max-w-md w-full">
              <input 
                type="email" 
                placeholder="Enter your email..." 
                className="flex-1 px-6 py-3 rounded-l-lg text-gray-800 focus:outline-none"
              />
              <button className="bg-white text-pink-500 px-8 py-3 rounded-r-lg font-semibold hover:bg-gray-100 transition-colors duration-300">
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Feed */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-gray-600 mb-2">Follow us on Instagram @candyliciouscreations</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {instagramImages.map((image, index) => (
              <div key={index} className="aspect-square relative group overflow-hidden rounded-lg">
                <img 
                  src={image} 
                  alt={`Instagram post ${index + 1}`} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                  <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <button className="bg-pink-500 text-white px-8 py-3 rounded-lg hover:bg-pink-600 transition-colors duration-300">
              Load More
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center">
                  <div className="w-6 h-6 border-2 border-white rounded-full border-dashed"></div>
                </div>
                <span className="text-2xl font-bold">Candylicious Creations</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                Nigeria's premier destination for American candy and sweet treats. 
                Bringing joy one candy at a time.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">LAGOS STORE</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <p>72 Kusenla Road</p>
                <p>Ikate Elegushi Lagos</p>
                <p>Lekki 105102, Nigeria</p>
                <p>+234 XXX XXX XXXX</p>
                <p>Mon - Sat: 9AM - 8PM</p>
                <p>Sunday: 11AM - 6PM</p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">CONTACT INFO</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <div className="flex items-center space-x-2">
                  <Phone className="w-4 h-4" />
                  <span>+234 XXX XXX XXXX</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Mail className="w-4 h-4" />
                  <span>hello@candylicious.ng</span>
                </div>
                <div className="flex items-center space-x-2">
                  <MapPin className="w-4 h-4" />
                  <span>Lagos, Nigeria</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">SUBSCRIBE TO OUR NEWSLETTER</h4>
              <div className="space-y-4">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="w-full px-4 py-2 bg-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
                />
                <button className="w-full bg-pink-500 text-white py-2 rounded hover:bg-pink-600 transition-colors duration-300">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © 2025 Candylicious Creations. All rights reserved. | Made with 🍭 in Nigeria
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CandyLandingPage;